import axios from "axios";

export const fetchDeleteJobTitle = async (jobId: string) => {
  return axios.delete(`/api/company/job/${jobId}`);
};
